import { makeStyles } from '@material-ui/styles';

const heightForSupportPageContainer = 36;

export const ErrorPageStyle = makeStyles({
  supportContainerHeight: {
    height: heightForSupportPageContainer,
  },
  imageAndReloadButtonHeight: {
    height: `calc(100% - ${heightForSupportPageContainer}px)`,
  },
  displayGrid: {
    display: 'flex',
    height: '100%',
    paddingBottom: 10,
    paddingTop: 10,
  },
  fullHeight: {
    height: '100%',
  },
  marginBetweenMessageAndButton: {
    marginBottom: 20,
    marginTop: 20,
  },
  linkPurpleColor: {
    color: '#8067E5',
    textDecoration: 'none',
  },
  errorButton: {
    backgroundColor: '#42AFE4',
    fontWeight: 'bold',
    '&&:hover': {
      backgroundColor: '#1976d2',
    },
  },
  reloadTypography: {
    color: '#fff',
  },
  centerText: {
    textAlign: 'center',
  },
});
